import React from "react";
import {createRoot} from "react-dom/client";
import embedOptions from "../configuration/embed.json";
import Playerlib from "../libs/player";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";
import "../../sass/_embed.scss";



class Embed extends React.PureComponent {
    loadSettings() {
        return embedOptions.map((option, index) => {
            const response = {};
            response[option.code] = option.value;
            return response;
        })
    }

    injectTag(src, type = 'script') {
        if (!src) return false;
        if (type === 'script') {
            let script = document.createElement("script")
            script.type = "text/javascript";
            script.async = true;
            script.src = src;
            const SS = document.getElementsByTagName('script');
            const s = SS[SS.length - 1];
            s.parentNode.insertBefore(script, s);
        } else if (type === 'link') {
            let link = document.createElement("link")
            link.rel = "stylesheet";
            link.href = src;
            const s = document.getElementsByTagName('head')[0];
            s.appendChild(link, s);
        }
        return true;
    }

    componentDidMount() {
        this.injectTag("//cdnjs.tvpage.com/tvplayer/tvp-master.min.js");
        setTimeout(this.init.bind(this), 20);
    }

    init() {
        const params = this.getUrlParams();
        const playerInit = {
            play_button_border_radius: '50%',
            play_button_border_width: '5px',
            play_button_border_color: theme.play_icon_color,
            play_button_border_style: 'solid',
            play_button_background_color: theme.play_icon_color,
            progress_color: theme.player_progressbar_color,
            api_base_url: ConfigurationHelper.getGlobalConfiguration().apiUrl,
            data: [{...this.props.video, ...this.props.video.data}],
            analytics: true,
            autoplay: false,
            autonext: false,
            player_version: "master",
            loginId: TVSite.loginId
        };

        const options = this.extend(playerInit, params);
        return new Playerlib('tvp-player-el', options, {
            onChange: this.playerStateChange
        });
    }

    getUrlParams() {
        if (!window.location) return;
        var o = {}, kv = location.search.substr(1).split('&'), params = [];
        for (var i = 0; i < kv.length; i++) {
            params.push(kv[i]);
        }
        for (var i = 0; i < params.length; i++) {
            var param = params[i].split('=');
            if (param[1]) o[param[0]] = param[1];
        }
        return o;
    }

    extend(out) {
        out = out || {};
        for (var i = 1; i < arguments.length; i++) {
            if (!arguments[i])
                continue;

            for (var key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key))
                    out[key] = arguments[i][key];
            }
        }
        return out;
    }

    render() {
        return (
            <div>
                <div className="tvp-player">
                    <div id="tvp-player-el"></div>
                </div>
            </div>
        )
    }
}

const root = createRoot(document.getElementById("root"))
root.render(<Embed video={TVSite.video} config={TVSite.config}/>);